import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import createMessagingService from 'services/MessagingService/MessagingService';
import {
  CASHOUT_STATUS_RESPONSE,
  STUDIO_ROSTER_RESPONSE,
  STUDIO_PERFORMER_RESPONSE,
} from 'services/MessagingService/EventNames';
import parseCatch from 'utils/parseCatch';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

const CASHOUT_STATUS_URL = `${BASE_URL}/rest/v1.0/user-paypal-statuses/{username}`;
const ROSTER_URL = `${BASE_URL}/rest/v1.0/studio/{username}/roster?fresh=true`;
const studioPerformerUrl = (studioOwnerName, performer) =>
  `${BASE_URL}/rest/v1.0/studio/${studioOwnerName}/roster/${performer}?fresh=true`;

export class CashoutVerificationService {
  /**
   * Constructor of @CashoutVerificationService class.
   * @param {function} createMessagingService a MessagingService creator
   * Bind methods to messaging service events
   */
  constructor() {
    this.messagingService = createMessagingService();
  }

  destructor() {
    this.messagingService = null;
  }

  /**
   * @async
   * Method for getting user cashout status
   * @param {String} username
   * @returns promise
   * @emits CASHOUT_STATUS_RESPONSE when API call is successful
   */
  getCashoutStatus = (username, headers = {}) => {
    const url = ApiService.substitute(CASHOUT_STATUS_URL, { username: encodeURIComponent(username) });
    ApiService.get(url, { headers })
      .then((res) => this.messagingService.emit(CASHOUT_STATUS_RESPONSE, res.data))
      .catch((error) => parseCatch(error));
  };

  getCashoutStatusAsync = async(username, headers = {}) => {
    const url = ApiService.substitute(CASHOUT_STATUS_URL, { username: encodeURIComponent(username) });
    await ApiService.get(url, { headers })
      .then((res) => this.messagingService.emit(CASHOUT_STATUS_RESPONSE, res.data))
      .catch((error) => parseCatch(error));
  };

  getStudioRoster = (username) => {
    const url = ApiService.substitute(ROSTER_URL, { username: encodeURIComponent(username) });
    ApiService.get(url)
      .then((res) => this.messagingService.emit(STUDIO_ROSTER_RESPONSE, res.data))
      .catch((error) => parseCatch(error));
  };

  getStudioPerformer = (studioOwnerName, performer) => {
    const url = studioPerformerUrl(studioOwnerName, performer);
    ApiService.get(url).then((res) => this.messagingService.emit(STUDIO_PERFORMER_RESPONSE, res.data));
  };
}

export default new CashoutVerificationService();

